import React from 'react';
import styled from 'styled-components';
import TurnTable from './TurnTable';
import TurnFooter from './TurnFooter';
import ModalTurnAddNew, { turnAddNewRef } from './Modals/ModalTurnAddNew';
import ModalTurnDetail, { turnDetailRef } from './Modals/ModalTurnDetail';
import ModalTurnSetting, { turnSettingRef } from './Modals/ModalTurnSetting';
import StaffTurns from './StaffTurns';
import Box from 'components/Box';
import AlarmClockUI, { Today } from 'components/AlarmClockUI';
import TurnSort from './TurnTable/TurnSort';
import { turnManualSelectors } from 'modules/turn/services/selectors';
import { colorSetCodes } from 'modules/turn/services/constants';
import { get } from 'lodash';
import { ITurnManualSettingColorItem } from 'modules/turn/services/types/turn';

const TurnManualUI = () => {
  const turnSettingColors = turnManualSelectors.settingColors();
  return (
    <Container turnSettingColors={turnSettingColors}>
      <div className="wrapper-content">
        <Box display='flex' flexDirection='column' className="content-container">
          <Box className='TurnSortHeader' display='flex' alignItems='center' style={{ height: '64px' }}>
            <TurnSort />
            <Box display='flex' justifyContent='center' alignItems='center' style={{ flex: 1 }}>
              <Today style={{ marginRight: 24 }} format='ddd. MMM D, YYYY' />
              <AlarmClockUI />
            </Box>
          </Box>
          <div className="content-container">
            <div className="div-scroll">
              <TurnTable />
            </div>
          </div>
          <TurnFooter />
        </Box>
        <StaffTurns />
      </div>

      <ModalTurnAddNew ref={turnAddNewRef} />
      <ModalTurnDetail ref={turnDetailRef} />
      <ModalTurnSetting ref={turnSettingRef} />
    </Container>
  );
};

export default TurnManualUI;

const Container = styled.div<{ turnSettingColors: ITurnManualSettingColorItem[] }>`
display: flex;
flex-direction: column;
position: fixed;
inset: 0;
background: #F0F0F0;
.hour, .digital :last-child {
  font-weight: bold;
  color: #1D2129;
}

@keyframes zoom-in-zoom-out {
    0% {
      transform: scale(1, 1);
    }
    50% {
      transform: scale(1.5, 1.5);
    }
    100% {
      transform: scale(1, 1);
    }
  }

.wrapper-content {
  flex: 1;
  display: flex;
}
.content-container {
  flex: 1;
  position: relative;
  align-self: stretch;
  .div-scroll {
    position: absolute;
    inset: 0;
    overflow: auto;
    scrollbar-width: none; /* Firefox 64 */
    &::-webkit-scrollbar {
      width: 0px;
      height: 8px;
      background-color: #F5F5F5;
    }
  
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0,0,0,0.5);
      &:hover {
        background-color: rgba(0,0,0,0.6);
      }
    }
  }
}
 
@media only screen and (max-width: 1500px) {
  .staff-top-row-sticky {
    font-size: 12px;
  }
  .wrapper-content {
    .TurnSortHeader {
      height: 40px !important;
    }
  }

  .TurnHeadItem .box-item {
    with: 55px;
    .box-turn {
      width: 35px;
      height: 35px;
    }
  }

  .TurnStaffTopRow {
    &.voiceCallStaff {
      min-width: 165px;
      max-width: 165px;
    }

    .ant-avatar {
      width: 40px !important;
      height: 40px !important;
      line-height: 40px !important;
      font-size: 18px !important;
    }

    .CallStaffIcon {
      width: 32px !important;
      height: 32px !important;
    }

    &.timeAppointment .ant-avatar {
      width: 32px !important;
      height: 32px !important;
      line-height: 32px !important;
      font-size: 18px !important;
    }
    .time-container span {
      font-size: 12px;
    }
    .staff-name {
      font-size: 12px;
      max-width: 55px !important;
      min-width: 55px !important;
    }
  }

  table tbody {
    .TurnBodyItem .box-item {
      ${({ turnSettingColors }) => turnSettingColors.map(o => {
  const theme = get(colorSetCodes, o?.color || '');
  if (o.turnStatus === 'NEXT')
    return `&.${o.turnStatus} {
              background: ${theme.bg};
              border: 0.5px solid ${theme.stroke};
              box-shadow: 3px 3px 0px 0px ${theme.shadow};
              .container-full {
                background: ${theme.bg};
              }
            
            }`;
  return `&.${o.turnStatus} {
            background: ${theme.bg};
            border: 0.5px solid ${theme.stroke};
            box-shadow: 3px 3px 0px 0px ${theme.shadow};
          }`;
})
  }
    }
    td {
      background: #fff;

    }
    td.staff-top-row-sticky {
      position: sticky;
      left: 0px;
      background: #fff;
      z-index: 2;
      transform: translateX(-2px);

      &.active {
        background: #C6E9EF;
      }
    }

    .TurnBodyItem .box-item{
      width: 40px;
      height: 40px;

      .service-text {
        font-size: 12px;
        margin-bottom: 4px;
      }
      .container-half .half-bg {
        inset: -16px;
        transform: scale(1);
      }

      .next-icon img {
        width: 24px !important;
        height: 24px !important;
      }
      .iconCheck {
        width: 16px !important;
        height: 16px !important;
        zoom: 0.8;
      }
    }

    .TurnBodyItem.active {
      .box-item {
        box-shadow: 0px 0px 0px 2px red!important;
      }
    }
  }

  .TurnFooter {
    padding: 8px 16px;
    zoom: 0.85;

    .TurnActions {
      margin-right: 0px;
      padding-right: 8px;
      .button-configs {
        gap: 8px;
        row-gap: 8px;
      }
      .button-configs button.btn{
        padding: 4px 8px;
        height: 40px;
        gap: 2px;
        .icon {
          width: 24px;
          svg {
            width: 20px;
            height: 20px;
          }
        }
        span {
          font-size: 10px;
        }
      }
    }

    .TurnTypes {
      padding-right: 0px;
      margin-right: 8px;
      gap: 8px;
      row-gap: 10px;

      button.btn, button.btn-summary {
        height: 40px;

        ${({ turnSettingColors }) => turnSettingColors.map(o => {
    const theme = get(colorSetCodes, o?.color || '');
    return `&.${o.turnStatus} {
                border: 1.5px solid #1D2129;
                .box-item {
                  background: ${theme.bg};
                  border: 0.5px solid ${theme.stroke};
                  box-shadow: 2px 2px 0px 0px ${theme.shadow};
                }
              }`;
  })}
      }

      button.btn-summary .box-item {
        border: 0.5px solid #D94452;
        box-shadow: 2px 2px 0px 0px #D94452;
         &.half {
          border: 0.5px solid #CCD4DC;
          background: #F0F0F0;
          box-shadow: none;

          .half-bg {
            transform: scale(0.5);
          }
        }
      }

      .box-item {
        width: 24px !important;
        height: 24px !important;
        .label-type {
          font-size: 8px;
        }
        .icon-completed {
          zoom: 0.8;
        }
      }
      .label-type {
        font-size: 10px;
      }
    }

    .TurnServices {
      .container-services {
        gap: 8px;
      }
      .container-services .btn.btn-arrow {
        width: 40px;
        height: 40px;
      }

      .TurnServiceItem .box-item {
        width: 40px;
        height: 40px;
        .service-text {
          font-size: 10px;
        }

        .container-half .half-bg {
          transform: scale(0.8);
          inset: -10px;
        }
      }
    }

  }

  .StaffTurns {
    .switch-container {
      height: 40px !important;
      .ant-switch {
          transform: scale(1);
      }
    }
    .ZoomInOut {
      .btn.btn-zoom {
        height: 34px !important;
        width: 34px !important;
      }
    }

    .staff-turn-list-container {
      .staff-turn-list {
        padding: 16px 8px;
        .StaffRowItem .box-text {
          height: unset;
          min-width: 80px;
          .CONTENT_2 {
            font-size: 12px;
          }
        }
      }
    
    }

    .MangersStyled {
      .header-section {
        padding: 4px 16px;
        .CONTENT_2 {
          font-size: 12px;
        }
      }

      .StaffManagerItem .box-text {
        height: unset;
        padding: 4px 16px;
        min-width: 80px;
        .ant-avatar.ant-avatar-circle.ant-avatar-image {
          width: 32px !important;
          height: 32px !important;
          line-height: 32px !important;
          font-size: 12px !important;
        }

        .CONTENT_2.text-overflow {
          font-size: 12px;
        }
      }
    }

    .fozito-icon-container .fozito-icon {
      width: 115px;
      height: 79.5px;
      padding: 0;
    }
  }


}
`;

